<template>
	<Disclosure as="nav" class="bg-mabey-950" data-testid="navbar">
		<div class="mx-auto px-4">
			<div class="relative flex h-16 items-center justify-between">
				<div class="flex flex-1 items-center justify-start">
					<Bars3BottomLeftIcon
						v-if="navigation && appStore.sidebar && desktop"
						class="h-6 w-6 mr-4 text-white"
						aria-hidden="true"
						@click="appStore.toggleSidebar(desktop)" />

					<XMarkIcon
						v-else-if="navigation && appStore.sidebar && !desktop"
						class="h-6 w-6 mr-4 text-white"
						aria-hidden="true"
						@click="appStore.toggleSidebar(desktop)" />

					<Bars3Icon
						v-else-if="navigation"
						class="h-6 w-6 mr-4 text-white"
						aria-hidden="true"
						@click="appStore.toggleSidebar(desktop)" />

					<div class="flex flex-shrink-0 items-center">
						<img
							class="h-8 w-auto"
							src="@/assets/image/logo-white-small.png"
							alt="Mabey Hire"
							data-testid="logo" />
					</div>
					<div
v-if="router.currentRoute.value.meta.group === 'product-data'"
						 class="hidden sm:ml-6 sm:block">
						<div class="flex space-x-4">
							<app-search />
						</div>
					</div>
				</div>
				<div
					class="absolute inset-y-0 right-0 flex items-center gap-2 pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
					<app-button
						v-if="launchpad"
						:to="launchpad"
						theme="info"
						size="small"
						icon="fa-rocket"
						data-testid="launchpad-button">
						Launchpad
					</app-button>

					<app-navbar-account data-testid="account-menu" />
				</div>
			</div>
		</div>
	</Disclosure>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'
	import useAppStore from '@/stores/app'
	import { Disclosure } from '@headlessui/vue'
	import { Bars3Icon, Bars3BottomLeftIcon, XMarkIcon } from '@heroicons/vue/24/outline'
	import AppNavbarAccount from './AppNavbarAccount.vue'
	import AppSearch from '@/components/layout/navbar/AppSearch.vue'
	import router from '@/router'


	const desktop = computed(() => {
		return window.innerWidth > 1024
	})

	const appStore = useAppStore()

	defineProps({
		navigation: Boolean
	})

	const launchpad = import.meta.env.VITE_LAUNCHPAD_URL ?? ''
</script>
